import { lang, commonLang, isLang } from '@umu/ukit-lang';
import React from 'react';
import { isInMobile } from '@umu/umu-ua';
import { isInIframe } from '@umu/umu-dom';
import { getModuleData } from 'common/src/services';
import { QrGenerator } from '../qrCode';
import { useMobileIframeLandscapeDisplayManager } from '../../services/responsiveDisplay/course';
import './pageSideQrCode.scss';

interface IProps {
    /**
     * 自定义 url 生成二维码，默认使用当前页面的 url
     */
    pageQrUrl?: string;

    /**
     * 有访问码时，引导文案会变为 pin 地址
     */
    accessCode?: string;
    // https://blog.logrocket.com/using-react-children-prop-typescript/
    children?: React.ReactNode;
    codeOptions?: IQRCodeOptions;
}

function PageSideQrCode(props: IProps) {
    const { isDisplayInIframeModeForCourse } = useMobileIframeLandscapeDisplayManager();
    if (isInMobile()) {
        return null;
    }

    if (isInIframe() && !isDisplayInIframeModeForCourse) {
        return null;
    }

    return <PageSideQrCodeInner {...props} />;
}

const PageSideQrCodeInner = (props: IProps) => {
    const { isDisplayInIframeModeForCourse } = useMobileIframeLandscapeDisplayManager();
    const renderDesc = () => {
        const accessCode = props.accessCode;

        if (!accessCode) {
            return (
                <div className="desc">
                    <p>
                        {commonLang('扫描二维码')}
                        <br />
                        <span dangerouslySetInnerHTML={{ __html: lang('用手机查看') }}></span>
                    </p>
                </div>
            );
        }

        const pinUrl = `pin.${getModuleData('siteHost')}`;
        let displayhint = (
            <>
                {lang('打开{$0}输入访问码', pinUrl)}
                <br />
                {lang('或扫描二维码用手机查看')}
            </>
        );
        if (isLang('cn')) {
            const hintSegs = (lang('打开{$0}输入访问码', pinUrl) + lang('或扫描二维码用手机查看'))
                .replace('输入', '<br />输入')
                .replace('或扫描', '<br />或扫描')
                .replace('用手机', '<br />用手机')
                .split('<br />');
            displayhint = (
                <>
                    {hintSegs.map((partStr: string, index: number) => {
                        if (index < hintSegs.length - 1) {
                            return (
                                <React.Fragment key={index}>
                                    {partStr}
                                    <br />
                                </React.Fragment>
                            );
                        } else {
                            return partStr;
                        }
                    })}
                </>
            );
        }
        return (
            <div className="desc access-code-desc">
                <p className="access-code-wrap">
                    <span>
                        {lang('访问码')}
                        {commonLang('：')}
                    </span>
                    <span className="access-code">{accessCode}</span>
                </p>
                <hr />
                <p className="access-code-tips">{displayhint}</p>
            </div>
        );
    };

    return (
        <div className={`doc-fixed top ${isDisplayInIframeModeForCourse ? 'qr-landscape' : ''}`}>
            <div className="page-qrcode">
                <div className="page-qrcode-main">
                    <div className="img">
                        <QrGenerator url={props.pageQrUrl} codeOptions={props.codeOptions} />
                    </div>
                    {renderDesc()}
                    {props.children}
                </div>
            </div>
        </div>
    );
};

export default PageSideQrCode;
